import { isDesktopBrowser } from '@psl/components/styles/responsive';
import { config } from '@psl/functions/config';
import { Dimensions } from 'react-native';

interface FitEnum {
  contain: 'contain';
  cover: 'cover';
  fill: 'fill';
  inside: 'inside';
  outside: 'outside';
}

export interface ImageResizeOptions {
  width: number;
  /** Alternative means of specifying height. If both are present this take priority. */
  height: number;
  /** How the image should be resized to fit both provided dimensions, one of cover, contain, fill, inside or outside. (optional, default 'cover') */
  fit?: keyof FitEnum;
  /** Position, gravity or strategy to use when fit is cover or contain. (optional, default 'centre') */
  position?: number | string;
  /** Background colour when using a fit of contain, parsed by the color module, defaults to black without transparency. (optional, default {r:0,g:0,b:0,alpha:1}) */
  background?: string;
}

export const scale = Dimensions.get('window').scale;

const cache: { [url: string]: string } = {};

export function cachedResizedImage(url: string) {
  return cache[url] ?? url;
}

export const imageResize = (
  url: string | undefined,
  options: ImageResizeOptions,
) => {
  if (typeof url !== 'string') {
    return undefined;
  }
  if (!url.startsWith('http')) {
    return url;
  }
  if (url.includes('.gif')) {
    return url;
  }
  if (url.includes(config.imageResizeEndpoint)) {
    if (__DEV__) {
      console.warn('You are passing resized image to resize again?');
    }
    return url;
  }
  const params = {
    url,
    ...options,
    width: options.width * scale,
    height: options.height * scale,
  };
  const query = Object.keys(params)
    .map(key => `${key}=${encodeURIComponent((params as any)[key])}`)
    .join('&');
  const result = `${config.imageResizeEndpoint}?${query}`;
  cache[url] = result;
  return result;
};

export const avatarThumbnail = {
  width: 30,
  height: 30,
};

export const avatarPreview = {
  width: 60,
  height: 60,
};

export const showThumbnail = {
  width: 50,
  height: 50,
};

export const showCardSize = {
  width: 265,
  height: 440,
};

export const listingThumbnail = {
  width: 440,
  height: 440,
};

export const resizeToListingThumbnail = (_url: string | null | undefined) =>
  listingThumbnail;

export const resizeToListingThumbnailConditionally = (
  url: string | null | undefined,
) =>
  url?.includes('commentsold.com') && isDesktopBrowser()
    ? undefined
    : listingThumbnail;
